import actions from "../action/preorder";
import CONSTANT from "../constant/preorder";
import STATUS_CODE from "../constant/status_code";
import _ from "underscore";
import { MessageBox } from "mint-ui";
import cloneDeep from "lodash.clonedeep";
import op from "object-path";
import { getDistanceBetween2 } from "../util/function";

const originalState = {
  /* 基本数据 */
  orderInitInfo: {}, //从缓存接口取出来的数据，从商详页带过来用于下单
  orderKey: "", //订单号，或缓存的key
  preorderId: "", //初步单Id，
  orderType: 0,

  /* 收银台商品信息 */
  preorderGoods: [], // 全量商品数据
  preorderGoodsExtend: {}, // 商品扩展信息
  preorderSkuList: [], // sku列表，格式为后台接口指定格式
  /* 运费 */
  expressSku: {}, //运费sku

  /* 电影订单数据 */
  filmData: {},

  /* 支付限制，控制是否可用卡、券、积分 */
  payLimit: {},

  /* 卡 */
  cardsList: [],
  orderMatchCardNum: 0, //订单适用的卡数量
  selectedCards: {}, //用户选中的卡， 数据格式与后台消费校验接口 card字段一致
  cardSelectedFromDetail: {}, //在卡详情选中的卡

  /* 券 */
  couponsList: [],
  orderMatchCouponNum: 0, //订单适用的现金券数量
  selectedCoupon: {},

  /* 积分 */
  selectedBalance: {},
  hasUsedBalance: false,

  /* 地址 */
  addressErrorMsg: "", // 地址错误提示语，会阻拦下单流程
  addressPrompt: "", // 地址警告语， 不阻拦下单

  /* 特殊发货属性相关 */
  infoNeeded: {}, // 根据特殊发货属性，需要用户填写的信息
  deliveryInput: {
    // 特殊发货类型，用户输入的数据
    phone: "",
    oilCardId: "",
    deliveryTime: {
      date: "",
      time: "",
    },
    deliveryTime1: {
      date: "",
      time: "",
    },
    shopper: {
      name: "",
      mobile: "",
    },
    o2oType: 0, // o2o发活类型 1、商家配送。 2、用户自提
    candleNumber: [], // 数字蜡烛下单时，指定的数字
    selectedStore: {}, // 收银台选中的门店

    examine: {
      agency: {}, // 选中的体检机构
      time: "", // 预约时间
      examiner: [], // 体检人
    },
    rechargeAccount: "", // 充值帐号
  },
  preorderStore: [], // 收银台选中的门店列表

  /* sku普通扩展信息 */
  extendInput: [], //商品扩展信息输入框
  extendInputValue: [], //用户输入的扩展信息的值

  /* 搭售 */
  bundleSaleData: {
    // 搭售相关的数据
    title: "",
    freeGiftText: "",
    list: [],
  }, // 搭售数据
  isSelectedbundleSale: false, // 用来通知收银台刷新数据

  /* 发票 */
  invoiceInfo: {}, //发票信息
  canInvoice: 1, //是否可开发票 0不可 1可

  /* 其他 */
  actionInfo: {
    // 活动信息
    activeCode: "",
    groupCode: "",
  },
  feedBackMsg: "", //用户下单留言

  // clearanceType: 0,
  businessInfo: {},

  /* 体检 */
  examineAgencyList: [],
  /** 选择组合的临时数据，用户点击确认按钮以后，需要再次回写填充的数据 */
  selectDataTemp: {},
};

export default {
  actions,
  state: {
    ...cloneDeep(originalState),
  },
  mutations: {
    setInitInfo(state, data) {
      state.orderInitInfo = data;
      if (data[0].type == 2) {
        state.deliveryInput.phone = data[0].number;
      } else {
        state.deliveryInput.oilCardId = data[0].number;
      }
    },
    setActionInfo(state, data) {
      state.actionInfo = data;
    },
    setAddressErrorMsg(state, msg) {
      state.addressErrorMsg = msg;
    },
    setAssetFromSession(state, selected) {
      const { selectedCard, selectedCoupon, selectedBalance } = selected;
      if (!_.isEmpty(selectedCoupon)) {
        state.selectedCoupon = selectedCoupon;
      }

      if (!_.isEmpty(selectedCard)) {
        state.selectedCards = selectedCard;
      }

      if (!_.isEmpty(selectedBalance)) {
        state.selectedBalance = selectedBalance;
      }
    },
    setAddressPrompt(state, msg) {
      state.addressPrompt = msg;
    },
    setPreorderId(state, key) {
      return (state.preorderId = key);
    },
    selectCardFromDetail(state, card) {
      state.cardSelectedFromDetail = card;
    },
    setInfoNeeded(state, data) {
      state.infoNeeded = data;
    },
    clearSelectedCards(state) {
      state.selectedCards = {};
    },
    clearSelectedCoupons(state) {
      state.selectedCoupon = {};
    },
    setOrderKey(state, data) {
      return (state.orderKey = data);
    },
    setPreorderGoods(state, data) {
      return (state.preorderGoods = data);
    },
    setPreorderSkuList(state, data) {
      return (state.preorderSkuList = data);
    },
    setPreorderStore(state, data) {
      return (state.preorderStore = data);
    },
    initState(state) {
      state = Object.assign(state, {
        ...cloneDeep(originalState),
      });
    },
    updateExtendValue(state, data) {
      let newData = _.clone(state.extendInputValue);
      newData[data.index] = data.value;
      return (state.extendInputValue = newData);
    },
    setOrderType(state, data) {
      return (state.orderType = data);
    },

    setInputPhone(state, data) {
      return (state.deliveryInput.phone = data);
    },
    setInputOilCardId(state, data) {
      return (state.deliveryInput.oilCardId = data);
    },
    setFeedbackMsg(state, data) {
      return (state.feedBackMsg = data);
    },
    cancelUseBalance(state, data) {
      return (state.hasUsedBalance = false);
    },
    useBalance(state, data) {
      return (state.hasUsedBalance = true);
    },
    setInputShopper(state, data) {
      state.deliveryInput.shopper = data;
    },
    setDeliveryTime(state, data) {
      state.deliveryInput.deliveryTime = data;
    },
    setDeliveryTime1(state, data) {
      state.deliveryInput.deliveryTime1 = data;
    },
    updataBundleSaleGoods(state, status) {
      state.isSelectedbundleSale = status;
    },
    setSelectedStore(state, store) {
      state.deliveryInput.selectedStore = store;
    },
    setCandleNumber(state, { index, value }) {
      let newNumbers = cloneDeep(state.deliveryInput.candleNumber);

      newNumbers[index] = value;

      state.deliveryInput.candleNumber = newNumbers;
    },
    setO2OType(state, data) {
      if (data !== state.deliveryInput.o2oType) {
        state.deliveryInput.deliveryTime = {
          time: "",
          date: "",
        };
        state.deliveryInput.selectedStore = {};
      }
      state.deliveryInput.o2oType = data;
    },
    setBusinessInfo(state, data) {
      state.businessInfo = data;
    },
    setDeliveryInputExamineTime(state, time) {
      state.deliveryInput.examine.time = time;
    },
    setDeliveryInputExaminer(state, examiner) {
      state.deliveryInput.examine.examiner = examiner;
    },
    setDeliveryInputRechargeAccount(state, account) {
      state.deliveryInput.rechargeAccount = account;
    },
    setDeliveryInputExamineAgency(state, agency) {
      state.deliveryInput.examine.agency = agency;
    },
    [CONSTANT.PREORDER_MATCHCARDTOTAL_SUCCESS](state, data) {
      state.orderMatchCardNum = data.total;
    },
    [CONSTANT.PREORDER_MATCHCARDTOTAL_ERROR](state, e) {},
    // [CONSTANT.PREORDER_ORDERCARDCHECK_SUCCESS](state, data) {
    //   state.selectedCards = data
    //   if (!_.isEmpty(state.cardsList)) {
    //     _.each(state.cardsList, card => {
    //       card.isChoosed = false
    //     })
    //     _.each(data.cardList, selected => {
    //       _.each(state.cardsList, card => {
    //         if (selected.cardNum == card.cardNum) {
    //           _.extend(card, selected)
    //           _.extend(selected, card)
    //           card.isChoosed = true
    //           card.selectCount = card.canSelectCount ? _.reduce(card.deductionList, (a, b) => {
    //             return (a || 0) + (b.deductedCount || 0)
    //           }, 0) || 0 : 0
    //           card.canAdd = !op(data).get('card.deductionInfo.isFullDeduction')
    //         }
    //       })
    //     })
    //   }
    // },
    [CONSTANT.PREORDER_ORDERCARDCHECK_ERROR](state, e) {},
    [CONSTANT.PREORDER_MATCHORDERCARDLIST_SUCCESS](state, params) {
      const { type, data } = params;

      // 先给card对象加上isChoosed属性，确保vue一定能跟踪到这个值
      _.each(data, (card) => {
        card.isChoosed = false;
      });
      const selectedCardsOld = op(state).get("selectedCards") || {};
      const selectedCardsNew = op(state).get("selectDataTemp.card") || {};
      // 苏打券需要确认后，使用临时数据进行处理
      const selectedCards =
        type === "init" ? selectedCardsOld : selectedCardsNew;

      //把已被勾选的卡都打上标志
      if (!_.isEmpty(selectedCards)) {
        _.each(op(selectedCards).get("epayList"), (selected) => {
          _.each(data, (card) => {
            if (selected.epayNumber == card.cardNum) {
              _.extend(card, selected);
              _.extend(selected, card);
              card.isChoosed = true;
              card.selectCount = card.canSelectCount
                ? _.reduce(
                    card.deductionList,
                    (a, b) => {
                      return (a || 0) + (b.deductedCount || 0);
                    },
                    0
                  ) || 0
                : 0;
              card.canAdd = !op(data).get("card.deductionInfo.isFullDeduction");
            } else {
              card.isChoosed = false;
            }
          });
        });
      }
      if (type === "init") {
        // state.selectedCards = cloneDeep(state.selectedCards);
        state.selectedCards = cloneDeep(selectedCards);
      }
      // 进入页面初始化时，保存临时数据和当前选中卡数据完全相同，（ps,用户选中以后数据临时数据更新，但是直接退回没有确认，此时临时数据和确认过的数据不同，导致后续操作异常）
      // 这里的思路是：进入页面时使用确认后的数据进行初始化处理，后续任何操作都使用临时数据 （只有点击确认时临时数据===确认数据，没点确认时，这里需要再初始化时保持一致）
      if (state.selectDataTemp.card) {
        // 加载更多时也会进入这里，这里临时数据也需要刷新，此时直接使用自己的临时数据刷新的
        state.selectDataTemp.card = cloneDeep(selectedCards);
      }
      state.cardsList = data;

      /*  state.cardsList = _.uniq(data.concat(state.cardsList), (card) => {
           return card.cardNum;
       }) */
    },
    [CONSTANT.PREORDER_MATCHORDERCARDLIST_ERROR](state, e) {},
    [CONSTANT.PREORDER_GETPREORDERINFO_SUCCESS](state, data) {},
    [CONSTANT.PREORDER_GETPREORDERINFO_ERROR](state, e) {},
    [CONSTANT.PREORDER_GETPREORDERSKUS_SUCCESS](state, data) {
      // 将下单sku信息合到sku详情中
      const productInfos = data.list;
      const skuInfos = state.preorderSkuList;
      productInfos.forEach((p) => {
        skuInfos.forEach((s) => {
          if (p.sku.skuId === s.skuId) {
            p.buyCount = s.count;
            p.isTiedProduct = s.isTiedProduct;
            p.sku = _.extend(p.sku, s);
          }
        });
      });
      state.preorderGoods = productInfos;

      // 处始化商品列表分组
    },
    [CONSTANT.PREORDER_GETPREORDERSKUS_ERROR](state, e) {},
    [CONSTANT.PREORDER_GETPREORDERSKUEXTEND_SUCCESS](state, data) {
      //将数据填充进SKUlist
      _.each(state.preorderSkuList, (sku) => {
        _.each(data.list, (sku2) => {
          if (sku.skuId === sku2.skuId) {
            // sku.deliveryAttr = sku2.deliveryAttr
            _.extend(sku, sku2);
          }
        });
      });

      // 扩展属性，取并集
      let extend = [];
      _.each(data.list, (sku) => {
        if (sku.deliveryAttr) {
          extend = extend.concat(sku.deliveryAttr);
        }
      });
      extend = _.uniq(extend, (a) => {
        return a && a.attrId;
      });
      state.extendInput = extend;

      // 设置需要输入的
      let infoNeeded = [];
      _.each(data.list, (sku) => {
        _.each(sku.deliveryTypes, (delivery) => {
          infoNeeded[delivery.type] = delivery.value || true;
        });
      });

      // 运费sku
      state.infoNeeded = infoNeeded;
      state.expressSku = data.expressSku;
      state.preorderGoodsExtend = data;

      // // 清关类型
      // state.clearanceType = _.find(data.list, sku => {
      //   return sku.clearanceType != 0
      // })

      // 是否可以开发票
      state.canInvoice = data.canInvoice;
    },
    [CONSTANT.PREORDER_GETPREORDERSKUEXTEND_ERROR](state, e) {},
    [CONSTANT.PREORDER_GETFILMORDER_SUCCESS](state, data) {
      state.filmData = data;
      state.deliveryInput.phone = data.mobile;
    },
    [CONSTANT.PREORDER_GETFILMORDER_ERROR](state, e) {},
    [CONSTANT.PREORDER_CREATEORDER_SUCCESS](state, data) {},
    [CONSTANT.PREORDER_CREATEORDER_ERROR](state, e) {},
    [CONSTANT.PREORDER_CASHPAY_SUCCESS](state, data) {},
    [CONSTANT.PREORDER_CASHPAY_ERROR](state, e) {},
    [CONSTANT.PREORDER_CANCELTICKETORDER_SUCCESS](state, data) {},
    [CONSTANT.PREORDER_CANCELTICKETORDER_ERROR](state, e) {},
    [CONSTANT.PREORDER_GETDESIGNATEDCARDS_SUCCESS](state, params) {
      // optType init 初始化 | loadmore 加载更多
      const { optType, data } = params || {};
      // 合并选中的卡数据
      const selectedCardsOld = op(state).get("selectedCards.epayList") || [];
      const selectedCardsNew =
        op(state).get("selectDataTemp.card.epayList") || [];
      // 苏打券需要确认后，使用临时数据进行处理
      const selectedCards =
        optType === "init" ? selectedCardsOld : selectedCardsNew;

      _.each(data, (card) => {
        _.each(selectedCards, (aCard, index) => {
          if (aCard.epayNumber == card.cardNum) {
            card = _.extend(card, aCard);
            card.isChoosed = true;
            card.selectCount = card.canSelectCount
              ? _.reduce(
                  card.deductionList,
                  (a, b) => {
                    return (a || 0) + (b.deductedCount || 0);
                  },
                  0
                ) || 0
              : 0;
            aCard.selectCount = card.selectCount;
            card.sortNum = index + 1;
            card.canAdd = !op(state).get(
              "selectedCards.deductionInfo.isFullDeduction"
            );
          }
        });
      });

      // 把选中的卡合并到卡列表
      let cardConcat = data.concat(state.cardsList);
      let cardNumMap = {};
      let newCardList = [];
      cardConcat.forEach((c) => {
        if (!cardNumMap[c.cardNum]) {
          cardNumMap[c.cardNum] = true;
          newCardList.push(c);
        }
      });

      if (optType === "init") {
        state.selectedCards.epayList = selectedCards;
      }

      state.cardsList = newCardList;
    },
    [CONSTANT.PREORDER_GETDESIGNATEDCARDS_ERROR](state, e) {},
    [CONSTANT.PREORDER_GETPAYLIMIT_SUCCESS](state, data) {
      state.payLimit = data;
    },
    [CONSTANT.PREORDER_GETPAYLIMIT_ERROR](state, e) {
      MessageBox.alert(e);
    },
    [CONSTANT.PREORDER_ORDERCOUPONLIST_SUCCESS](state, data) {
      if (!_.isEmpty(op(state).get("selectedCoupon.epayList"))) {
        _.each(op(state).get("selectedCoupon.epayList"), (selected) => {
          _.each(data.list, (coupon) => {
            if (selected.epayId == coupon.couponsCodeId) {
              _.extend(coupon, selected);
              _.extend(selected, coupon);
              coupon.isChoosed = true;
            } else {
              coupon.isChoosed = false;
            }
          });
        });
      } else {
        _.each(data.list, (coupon) => {
          coupon.isChoosed = false;
        });
      }

      state.couponsList = _.sortBy(data.list, (coupon) => {
        return !coupon.isChoosed;
      });
    },
    [CONSTANT.PREORDER_ORDERCOUPONLIST_ERROR](state, e) {},
    [CONSTANT.PREORDER_GETORDERCOUPONNUM_SUCCESS](state, data) {
      state.orderMatchCouponNum = data.total;
    },
    [CONSTANT.PREORDER_GETORDERCOUPONNUM_ERROR](state, e) {},
    [CONSTANT.PREORDER_ORDEROPTIMALPAY_SUCCESS](state, data) {
      //卡数据合,并修改isCHoose状态
      if (!_.isEmpty(state.cardsList)) {
        _.each(state.cardsList, (card) => {
          card.isChoosed = false;
          card.selectCount = 0;
        });
        _.each(op(data).get("card.epayList"), (selected) => {
          _.each(state.cardsList, (card) => {
            if (selected.epayNumber == card.cardNum) {
              _.extend(card, selected);
              card.isChoosed = true;
              card.selectCount = card.canSelectCount
                ? _.reduce(
                    card.deductionList,
                    (a, b) => {
                      return (a || 0) + (b.deductedCount || 0);
                    },
                    0
                  ) || 0
                : 0;

              selected.selectCount = card.selectCount;

              card.canAdd = !op(data).get("card.deductionInfo.isFullDeduction");
            }
          });
        });
      }
      //修改现金券isChoose状态
      if (!_.isEmpty(state.couponsList)) {
        _.each(state.couponsList, (coupon) => {
          coupon.isChoosed = false;
        });
        _.each(op(data).get("coupon.epayList"), (selected) => {
          _.each(state.couponsList, (coupon) => {
            if (selected.epayId == coupon.couponsCodeId) {
              // _.extend(card, selected)
              coupon.isChoosed = true;
            }
          });
        });
      }

      state.selectedCards = data.card;
      state.selectedCoupon = data.coupon;
      state.selectedBalance = data.balance;

      if (op(data.balance).get("deductionInfo.deductionValue")) {
        state.hasUsedBalance = true;
      }
      state.expressSku = data.expressSku;
      if (data.payLimit) {
        state.payLimit = data.payLimit;
      }
    },
    [CONSTANT.PREORDER_ORDEROPTIMALPAY_ERROR](state, e) {},

    [CONSTANT.PREORDER_ORDERCHECKPAY_SUCCESS_CONFIRM](state, params = {}) {
      const { hasSelected } = params;
      if (hasSelected) {
        const data = state.selectDataTemp || {};
        state.selectedCards = data.card;
        state.selectedCoupon = data.coupon;
        state.selectedBalance = data.balance;
      } else {
        // 没有选中，点确定，直接清空历史值
        state.selectedCards = {};
        state.selectedCoupon = {};
        state.selectedBalance = {};
      }
    },

    [CONSTANT.PREORDER_ORDERCHECKPAY_SUCCESS](state, params) {
      const { needConfirm, ...data } = params || {};
      // 卡数据组合,并修改isCHoose状态
      if (!_.isEmpty(state.cardsList)) {
        _.each(state.cardsList, (card) => {
          card.isChoosed = false;
          card.selectCount = 0;
          card.sortNum = 0;
        });
        _.each(op(data).get("card.epayList"), (selected, index) => {
          _.each(state.cardsList, (card) => {
            if (selected.epayNumber == card.cardNum) {
              _.extend(card, selected);
              card.isChoosed = true;
              card.sortNum = index + 1;
              // 次卡内选中的票数
              card.selectCount = card.canSelectCount
                ? _.reduce(
                    card.deductionList,
                    (a, b) => {
                      return (a || 0) + (b.deductedCount || 0);
                    },
                    0
                  ) || 0
                : 0;
              selected.selectCount = card.selectCount;

              card.canAdd = !op(data).get("card.deductionInfo.isFullDeduction");
            }
          });
        });
      }

      //修改现金券isChoose状态
      if (!_.isEmpty(state.couponsList)) {
        _.each(state.couponsList, (coupon) => {
          coupon.isChoosed = false;
        });
        _.each(op(data).get("coupon.epayList"), (selected) => {
          _.each(state.couponsList, (coupon) => {
            if (selected.epayId == coupon.couponsCodeId) {
              // _.extend(card, selected)
              coupon.isChoosed = true;
            }
          });
        });
      }

      if (!needConfirm) {
        state.selectedCards = data.card;
        state.selectedCoupon = data.coupon;
        state.selectedBalance = data.balance;
      } else {
        // 需要确认时，先存储临时数据，后续点击确认按钮以后再设置
        state.selectDataTemp = data;
      }

      state.expressSku = data.expressSku;
      if (data.payLimit) {
        state.payLimit = data.payLimit;
      }
    },
    [CONSTANT.PREORDER_ORDERCHECKPAY_ERROR](state, e) {},
    [CONSTANT.PREORDER_CHECKLOGISTICS_SUCCESS](state, data) {
      state.preorderGoods.forEach((g) => {
        g.sku.skuStatus = 0;
      });
    },
    [CONSTANT.PREORDER_CHECKLOGISTICS_ERROR](state, e) {
      if (
        e.status ===
          STATUS_CODE.PREORDER_CHECK_LOGISTICS_ERROR_LACK_OF_PRODUCT_IN_AREA &&
        op(e).get("data.skuList")
      ) {
        const newList = [];
        state.preorderGoods.forEach((p) => {
          return e.data.skuList.forEach((sku) => {
            if (p.sku.skuId === sku.skuId) {
              newList.push({
                ...p,
                sku: {
                  ...p.sku,
                  skuStatus: sku.skuStatus,
                },
              });
            }
          });
        });

        state.preorderGoods = newList;
      }
    },
    [CONSTANT.PREORDER_GETSKULISTBYPREID_SUCCESS](state, data) {},
    [CONSTANT.PREORDER_GETSKULISTBYPREID_ERROR](state, e) {},
    [CONSTANT.PREORDER_PREORDERVERIFY_SUCCESS](state, data) {},
    [CONSTANT.PREORDER_PREORDERVERIFY_ERROR](state, e) {},
    [CONSTANT.PREORDER_GETCASHPAYWAY_SUCCESS](state, data) {},
    [CONSTANT.PREORDER_GETCASHPAYWAY_ERROR](state, e) {},
    [CONSTANT.PREORDER_CHANGEINVOICE_INPUT_SUCCESS](state, status) {
      state.invoiceInputShow = status;
    },
    [CONSTANT.PREORDER_SETINVOICEINFO_SUCCESS](state, info) {
      state.invoiceInfo = info;
    },
    [CONSTANT.PREORDER_GETTIEDPRODUCT_SUCCESS](state, data) {
      data.list.forEach((product) => {
        product.count = 0; // 初始化用户选中的搭售商品值
      });
      state.bundleSaleData = data;
    },
    [CONSTANT.PREORDER_GETTIEDPRODUCT_ERROR](state, e) {},
    [CONSTANT.PREORDER_GETORDERSTORELIST_SUCCESS](state, data) {
      // state.preorderStore = data.list

      // 按距离排序
      const position = this.getters.getGPSPostion;
      const list = _.chain(data.list)
        .map((item, index) => {
          const distance = getDistanceBetween2(
            `${item.la}:${item.lo}`,
            `${position.latitude}:${position.longitude}`
          );
          return { ...item, distance };
        })
        .sortBy((item) => parseFloat(item.distance))
        .value();
      state.preorderStore = list;
    },
    [CONSTANT.PREORDER_GETORDERSTORELIST_ERROR](state, e) {},
    [CONSTANT.PREORDER_ONORDEREVENT_SUCCESS](state, data) {},
    [CONSTANT.PREORDER_ONORDEREVENT_ERROR](state, e) {},
    [CONSTANT.PREORDER_GETEXAMINEAGENCYLISTOFPREORDER_SUCCESS](state, data) {
      const currentAgencyId = data.currentAgencyId;
      const currentAgency = _.find(data.list, (item) => {
        return item.agencyId === currentAgencyId;
      });

      state.deliveryInput.examine.agency = currentAgency;
      state.examineAgencyList = data.list;
    },
    [CONSTANT.PREORDER_GETEXAMINEAGENCYLISTOFPREORDER_ERROR](state, e) {},
    [CONSTANT.PREORDER_GETGIFTORDERSKUEXTEND_SUCCESS](state, data) {},
    [CONSTANT.PREORDER_GETGIFTORDERSKUEXTEND_ERROR](state, e) {},
    [CONSTANT.PREORDER_CHECKGIFTORDERLOGISTICS_SUCCESS](state, data) {},
    [CONSTANT.PREORDER_CHECKGIFTORDERLOGISTICS_ERROR](state, e) {},
    [CONSTANT.PREORDER_GETORDERREMINDMSG_SUCCESS](state, data) {},
    [CONSTANT.PREORDER_GETORDERREMINDMSG_ERROR](state, e) {},
    /*yeoman-template-point-1*/
  },
  getters: {
    // 多商品分组
    productGroup: (state) => {
      // 过滤搭售商品
      let goodsList = _.filter(state.preorderGoods, (g) => {
        return !g.isTiedProduct;
      });

      // 如果是单商品则返回
      if (goodsList.length < 1) {
        return [];
      }

      // 分组
      const tagsObject = {};
      goodsList.forEach((g) => {
        const groupTag = g.sku.groupTag;
        if (!tagsObject[groupTag]) {
          tagsObject[groupTag] = [];
        }
        tagsObject[groupTag].push(g);
      });

      const groupTags = [...state.preorderGoodsExtend.groupTags];
      return groupTags.map((gtag) => {
        return {
          ...gtag,
          totalGoodsNum: tagsObject[gtag.tag].reduce((total, current) => {
            return total + current.buyCount;
          }, 0),
          goods: tagsObject[gtag.tag],
        };
      });
    },
  },
};
